import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Skip authentication for auth endpoints
    const isAuthEndpoint = request.url.includes('/auth/');

    // Add auth token to request headers
    const token = this.authService.getToken();

    if (token && !isAuthEndpoint) {
      console.log('[AuthInterceptor] Adding token to request:', request.url);
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
    } else if (!token && !isAuthEndpoint) {
      console.warn('[AuthInterceptor] No token available for request:', request.url);
    }

    // Handle response errors
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          console.error('[AuthInterceptor] 401 Unauthorized - redirecting to login');
          // Unauthorized - clear auth and redirect to login
          this.authService.logout();
          this.router.navigate(['/auth/login']);
        } else if (error.status === 403) {
          console.error('[AuthInterceptor] 403 Forbidden - insufficient permissions or invalid token');
          // If 403, might be expired/invalid token - try to refresh or logout
          this.authService.logout();
          this.router.navigate(['/auth/login'], {
            queryParams: { returnUrl: this.router.url, error: 'session_expired' }
          });
        }
        return throwError(() => error);
      })
    );
  }
}
